<template>
    <div>
        <myPage :max_flag="true">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button size="small" icon="el-icon-refresh" @click="list()">刷新</el-button>
                </el-button-group>
                <div class="f-bd f14 text-nowrap">账期{{$t('x_mh')}}</div>
                <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
            </div>
            <div class="flex-box nopadding wrap pd-top10">
                <div class="round-10 card-box bg2 width-250 pd-10 mg-right10 mg-bottom10">
                    <div class="flex-box nopadding mg-top10">
                        <div class="flex-box-bd tleft">
                            <div class="f-red">
                                <span class="f18 mg-right3 f-bd num">{{day_info.mv_order_qty || 0}}</span>笔
                                <span class="mg-left3 mg-right3">/</span>
                                <span class="f18 mg-right3 f-bd num">{{(day_info.mv_goods_amt || 0) * 1}}</span>元
                            </div>
                            <div class="f14">成功笔数 / 面值</div>
                        </div>
                    </div>
                </div>
                <div class="round-10 card-box bg2 width-250 pd-10 mg-right10 mg-bottom10">
                    <div class="flex-box nopadding mg-top10">
                        <Icon class="icon-tag" type="ios-pie-outline" />
                        <div class="flex-box-bd tleft">
                            <div class="f-brown"><span class="f18 mg-right3 f-bd">{{ (day_info.mv_guest_cost_amt || 0)}}</span>元</div>
                            <div class="f14">客户结算价</div>
                        </div>
                    </div>
                </div>
                <div class="round-10 card-box bg2 width-250 pd-10 mg-right10 mg-bottom10">
                    <div class="flex-box nopadding mg-top10">
                        <Icon class="icon-tag" type="ios-infinite" />
                        <div class="flex-box-bd tleft">
                            <div class="f-brown"><span class="f18 mg-right3 f-bd">{{ (day_info.mv_cost_amt || 0)}}</span>元</div>
                            <div class="f14">供应商结算价</div>
                        </div>
                    </div>
                </div>
                <div class="round-10 card-box bg2 width-250 pd-10 mg-right10 mg-bottom10">
                    <div class="flex-box nopadding mg-top10">
                        <Icon class="icon-tag" type="md-funnel" />
                        <div class="flex-box-bd tleft">
                            <div class="num"><span class="f18 mg-right3 f-bd">{{ (day_info.mv_cr_cat10_qty || 0)}}</span>单</div>
                            <div class="f14">信誉按单量消耗</div>
                        </div>
                    </div>
                </div>
                <div class="round-10 card-box bg2 width-250 pd-10 mg-right10 mg-bottom10">
                    <div class="flex-box nopadding mg-top10">
                        <Icon class="icon-tag" type="logo-yen" />
                        <div class="flex-box-bd tleft">
                            <div class="num"><span class="f18 mg-right3 f-bd">{{ (day_info.mv_cr_cat20_qty * 1 || 0)}}</span>元</div>
                            <div class="f14">信誉按面额消耗</div>
                        </div>
                    </div>
                </div>
                <div class="round-10 card-box bg2 width-250 pd-10 mg-right10 mg-bottom10">
                    <div class="flex-box nopadding mg-top10">
                        <div class="flex-box-bd tleft">
                            <div class="f-red">
                                <span class="f18 mg-right3 f-bd num">{{day_info.fail_order_qty || 0}}</span>笔
                                <span class="mg-left3 mg-right3">/</span>
                                <span class="f18 mg-right3 f-bd num">{{(day_info.fail_goods_amt || 0) * 1}}</span>元
                            </div>
                            <div class="f14">失败笔数 / 面值</div>
                        </div>
                    </div>
                </div>
                <div class="round-10 card-box bg2 width-250 pd-10 mg-right10 mg-bottom10">
                    <div class="flex-box nopadding mg-top10">
                        <div class="flex-box-bd tleft">
                            <div class="f-red">
                                <span class="f18 mg-right3 f-bd num">{{day_info.wait_order_qty || 0}}</span>笔
                                <span class="mg-left3 mg-right3">/</span>
                                <span class="f18 mg-right3 f-bd num">{{(day_info.wait_goods_amt || 0) * 1}}</span>元
                            </div>
                            <div class="f14">充值中笔数 / 面值</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex-box nopadding mg-top20">
                <div class="flex-box-bd pd-10 bg-box" style="min-width: 500px">
                    <my-sub-title>分品类</my-sub-title>
                    <div class="mg-10 round-5 over-hide">
                        <myEcharsPie id='pie_day_goods' :rows="day_goods.rows" :name_key="day_goods.name_key" :value_key="day_goods.value_key" unit="单"></myEcharsPie>
                    </div>
                </div>
                <div class="mg-right10"></div>
                <div class="flex-box-bd pd-10 bg-box" style="min-width: 500px">
                    <my-sub-title>成功单量走势图表</my-sub-title>
                    <div class="mg-10 round-5 over-hide">
                        <myEcharsLine id="order_qty_area" :rows="order_qty_area.rows"
                                     :name_key="order_qty_area.name_key" :value_key="order_qty_area.value_key"></myEcharsLine>
                    </div>
                </div>
            </div>
            <div class="mg-top20">
                <my-sub-title>营收走势图表</my-sub-title>
<!--                <myEcharsCol id="goods_amt_area" :rows="goods_amt_area.rows" :line_value_key="goods_amt_area.line_value_key"-->
<!--                             :name_key="goods_amt_area.name_key" :value_key="goods_amt_area.value_key"></myEcharsCol>-->
                <myEcharsLine id="goods_amt_area" :rows="goods_amt_area.rows" :color="['#e54d42']"
                              :name_key="goods_amt_area.name_key" :value_key="goods_amt_area.value_key"></myEcharsLine>
            </div>
        </myPage>
    </div>
</template>

<script>
import myEcharsPie from '../../../components/myEcharsPie'
import myEcharsLine from '../../../components/myEcharsLine'
import myDatePicker from "../../../components/myDatePicker";
    export default {
        name: "report-sum",
        components:{
            myEcharsPie,
            myEcharsLine,
            myDatePicker
        },
        data:function(){
            return{
                search:{
                    search_url: "base-goodscat/list",
                    datearea_id:7,//如果大于0 mounted 要删除date_fr date_to
                    date_fr: '',
                    date_to: ''
                },
                day_info: {},
                day_goods: {
                    value_key:'order_qty',
                    name_key:'goods_cname',
                    rows: [],
                },
                goods_amt_area: {
                    value_key:'mv_goods_amt',
                    name_key:'date_no',
                    rows: [],
                },
                order_qty_area: {
                    value_key:'mv_order_qty',
                    name_key:'date_no',
                    rows: [],
                }
            }
        },
        mounted: function(){
            this.$base.setMenuActiveName();
            this.$base.listPageInit(this,()=>{
                this.list();
            });
        },
        methods: {
            onDateChange: function(data){
                this.search.date_fr = data[0];
                this.search.date_to = data[1];
                this.list();
            },
            list: function(){
                this.$base.showLoading();
                this.$request.sendPost("report-sum/list", this.search,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.day_info = data.day_info;
                        this.$nextTick(()=>{
                            this.day_goods.rows = data.day_goods;
                            this.goods_amt_area.rows = data.goods_amt_area;
                            this.order_qty_area.rows = data.goods_amt_area;
                        });
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/report/sum/list.vue